export default {"src":"/_next/static/media/LBRT.11d30be2.svg","height":18,"width":18};